import React from "react";
import { Link } from "react-router-dom";
import svasthLogo from "../../assets/images/svasth-logo.png";
import alegionLogo from "../../assets/images/alegionlogo.png";
import BrandTagline from "./BrandTagline";

const brands = {
  svasth: {
    src: svasthLogo,
    alt: "Svasth",
    label: "Svasth home",
    width: 168,
    height: 48,
  },
  alegion: {
    src: alegionLogo,
    alt: "ALEgiON HEALTH TECH",
    label: "ALEgiON HEALTH TECH home",
    width: 280,
    height: 48,
  },
};

/** Site brand mark — Svasth by default; Alegion on home */
const BrandMark = ({
  to,
  light = false,
  brand = "svasth",
  size = "md",
  className = "",
  showTagline,
}) => {
  const meta = brands[brand] || brands.svasth;
  const withTagline =
    typeof showTagline === "boolean"
      ? showTagline
      : brand === "alegion" || brand === "svasth";

  const content = (
    <span
      className={`sv-brand sv-brand--${brand} sv-brand--${size}${
        withTagline ? " sv-brand--stacked" : ""
      } ${light ? "sv-brand--light" : ""} ${className}`.trim()}
    >
      <img
        className="sv-brand__logo"
        src={meta.src}
        alt={meta.alt}
        width={meta.width}
        height={meta.height}
      />
      {withTagline ? (
        <BrandTagline
          light={light}
          className="sv-brand-tagline--nav"
        />
      ) : null}
    </span>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="sv-brand-link"
        aria-label={meta.label}
        onClick={() => {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }}
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default BrandMark;
